import { render, staticRenderFns } from "./form-agv-bank-details.vue?vue&type=template&id=1322755b&scoped=true&lang=pug&"
import script from "./form-agv-bank-details.vue?vue&type=script&lang=js&"
export * from "./form-agv-bank-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1322755b",
  null
  
)

export default component.exports